export const HE_INTERNAL_COMMENT_FIELD = 'InternalSubmissionComment';
export const HE_INTERNAL_COMMENT_MAX_LENGTH = 2000;

export function getHiredEquipmentInternalComment(
  fields: Array<{ field: string; value: string }>,
): string {
  return fields.find((field) => field.field === HE_INTERNAL_COMMENT_FIELD)?.value?.trim() ?? '';
}
